import React from "react";

const LEFT_LIST = [
  "Receive prototype development enquiries",
  "Find new customers and innovators",
  "Increase machine utilisation",
  "Build long-term relationships",
  "Expand visibility across Andhra Pradesh",
];

const RIGHT_LIST = [
  "Showcase machines and capabilities",
  "Submit quotations for projects",
  "Generate new business opportunities",
  "Showcase successful projects",
  "Participate in innovation programs",
];

function CheckIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, marginTop: "2px" }}
    >
      <circle cx="12" cy="12" r="9.25" stroke="#7f47ec" strokeWidth="1.6" />
      <path
        d="M8 12.5L10.5 15L16 9"
        stroke="#7f47ec"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowIcon() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#FFFFFF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ListItem({ text }) {
  return (
    <li
      style={{
        display: "flex",
        gap: "10px",
        alignItems: "flex-start",
        marginBottom: "18px",
        listStyle: "none",
      }}
    >
      <CheckIcon />
      <span
        style={{
          fontSize: "15.5px",
          color: "#1F2937",
          lineHeight: 1.5,
        }}
      >
        {text}
      </span>
    </li>
  );
}

export default function FacilityCentresHero() {
  return (
    <section
      style={{
        background: "#FFFFFF",
        padding: "72px 24px",
        fontFamily:
          "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
      }}
    >
      <div
        className="fc-grid"
        style={{
          maxWidth: "1180px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "56px",
          alignItems: "center",
        }}
      >
        {/* Left: image */}
        <div
          style={{
            position: "relative",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 20px 40px -12px rgba(15, 23, 42, 0.25)",
          }}
        >
          <div
            style={{
              width: "100%",
              paddingTop: "68%",
              position: "relative",
              background:
                "linear-gradient(135deg, #26324a 0%, #3b4a68 45%, #1c2534 100%)",
            }}
          >
            {/* Decorative machine-shop placeholder pattern */}
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage:
                  "repeating-linear-gradient(45deg, rgba(255,255,255,0.04) 0px, rgba(255,255,255,0.04) 2px, transparent 2px, transparent 14px)",
              }}
            />
            <div
              style={{
                position: "absolute",
                top: "16px",
                right: "20px",
                fontSize: "11px",
                fontWeight: 700,
                color: "rgba(255,255,255,0.85)",
                letterSpacing: "1px",
                textAlign: "right",
                lineHeight: 1.6,
              }}
            >
              INNOVATE
              <br />
              DESIGN
              <br />
              MANUFACTURE
            </div>

            {/* Overlay caption */}
            <div
              style={{
                position: "absolute",
                left: 0,
                right: 0,
                bottom: 0,
                padding: "28px 28px 24px",
                background:
                  "linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.55) 65%, rgba(0,0,0,0.75) 100%)",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: 800,
                  color: "#FFFFFF",
                  lineHeight: 1.35,
                }}
              >
                Your machines don't just manufacture parts.
                <br />
                <span style={{ color: "#7f47ec" }}>
                  They manufacture possibilities.
                </span>
              </p>
            </div>
          </div>
        </div>

        {/* Right: content */}
        <div>
          <span
            style={{
              display: "inline-block",
              fontSize: "13px",
              fontWeight: 700,
              letterSpacing: "1.5px",
              color: "#7f47ec",
              marginBottom: "14px",
              textTransform: "uppercase",
            }}
          >
            For Facility Centres
          </span>

          <h2
            style={{
              fontSize: "44px",
              fontWeight: 800,
              color: "#0B1F3A",
              margin: "0 0 22px 0",
              lineHeight: 1.18,
            }}
          >
            Turn Your Infrastructure Into an{" "}
            <span style={{ color: "#7f47ec" }}>Innovation Engine.</span>
          </h2>

          <p
            style={{
              fontSize: "16px",
              color: "#5B6779",
              lineHeight: 1.65,
              margin: "0 0 32px 0",
              maxWidth: "560px",
            }}
          >
            APIC ProtoHub enables facility centres, APIC centres,
            laboratories, fabrication units and specialised facilities to
            become part of a larger innovation ecosystem.
          </p>

          <div
            className="fc-lists"
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: "0 40px",
              marginBottom: "32px",
            }}
          >
            <ul style={{ margin: 0, padding: 0 }}>
              {LEFT_LIST.map((item) => (
                <ListItem key={item} text={item} />
              ))}
            </ul>
            <ul style={{ margin: 0, padding: 0 }}>
              {RIGHT_LIST.map((item) => (
                <ListItem key={item} text={item} />
              ))}
            </ul>
          </div>

          <button
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "10px",
              background: "#0B1F3A",
              color: "#FFFFFF",
              border: "none",
              borderRadius: "999px",
              padding: "16px 28px",
              fontSize: "15.5px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Register Your Facility Centre
            <ArrowIcon />
          </button>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .fc-grid {
            grid-template-columns: 1fr !important;
          }
        }
        @media (max-width: 560px) {
          .fc-lists {
            grid-template-columns: 1fr !important;
          }
          h2 {
            font-size: 32px !important;
          }
        }
      `}</style>
    </section>
  );
}